// extracted by css-extract-rspack-plugin
export default {"section":"Lq9XrHgUlDc8GflK","header":"JeBflOdmD8kS0dX4","heading":"INmZ80AYsEwzQ8QE","description":"xvF29fwaHUWhuJCB"};